import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { LocaleService } from '@sm360/widget-commons-core-services';

const EmptyResult = ({ colanders }) => {
    const resetUrl = LocaleService.t('FILTERS.URL_FILTER', {
        slug: colanders[0].urlMapping,
    });

    return (
        <div className="listing-used-car-no-result">
            <p>{LocaleService.t('NO_RESULT')}</p>
            <a className="listing-used-car-no-result__link sr-button-1" href={resetUrl}>
                {LocaleService.t('NO_RESULT_BUTTON_LABEL')}
            </a>
        </div>
    );
};

EmptyResult.propTypes = {
    colanders: PropTypes.arrayOf(
        PropTypes.shape({
            slug: PropTypes.string.isRequired,
            name: PropTypes.string.isRequired,
            displayName: PropTypes.string.isRequired,
            urlMapping: PropTypes.string.isRequired,
        }).isRequired
    ).isRequired,
};

function mapStateToProps({ listingUsed }) {
    return { colanders: listingUsed.colanders };
}

EmptyResult.displayName = 'EmptyResult';

export const component = EmptyResult;

export default connect(mapStateToProps)(EmptyResult);



// WEBPACK FOOTER //
// ./client/src/components/ListingUsed/EmptyResults/EmptyResult.jsx